import {translations} from 'presentation/translations-new';

const {stepsTitleMobile} = translations['pt-br'].privateFlow.bookingFlow;
const {professional, specialty, confirm} = stepsTitleMobile;

const HEADER_TITLES = [specialty, professional, confirm];

export {HEADER_TITLES};
